import { render, staticRenderFns } from "./AuditLogsView.vue?vue&type=template&id=700467a4&scoped=true&"
import script from "./AuditLogsView.vue?vue&type=script&lang=js&"
export * from "./AuditLogsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700467a4",
  null
  
)

export default component.exports